export interface AuthUser {
    userId: string
    companyId: string
}

export const getUser = (token?: string): AuthUser | undefined => {
    return token ? JSON.parse(window.atob(token.split(".")[1])) : undefined
}
